<template>
  <div class="standing">
    <div class="standing-bar">
      <el-row>
        <el-button size="small" icon="el-hg-icon-detail" @click="detail">详情</el-button>
        <el-button size="small" type="primary" icon="el-hg-icon-edit" @click="update">修改</el-button>
        <el-button size="small" type="danger" icon="el-hg-icon-delete" @click="adelete">删除</el-button>
        <el-button type="primary" size="small" icon="el-hg-icon-refreash" @click="refresh" class="marginLR">刷新</el-button>
      </el-row>
    </div>
    <!-- list view -->
    <div v-loading="loading" class="standing-list">
      <list class="list" :dataList.sync="aDataList" @detail="detail" ref="tableList" />
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryParams.currentPage" :page-sizes="pageSizes" :page-size="queryParams.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
      </div>
    </div>
    <my-dialog :show="bShowDialog" :dialogType.sync="dialogType" :id="currentId" @close="closeDialog" @refresh="refresh" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import list from './list';
import MyDialog from './dialog';

export default {
  name: 'echartManagement',
  components: {
    list,
    MyDialog
  },
  data() {
    return {
      bShowDialog: false,
      dialogType: '',
      currentId: null,
      aDataList: [],
      total: 0,
      loading: true,
      pageSizes: [10, 20, 50, 100],
      queryParams: {
        pageSize: 10,
        currentPage: 1,
        depCode: '',
        userId: ''
      }
    };
  },
  computed: {
    ...mapGetters({
      userInfor: 'user/userInfor',
      userId: 'user/userId'
    }),
    selected() {
      let ids = [];
      let sysList = [];
      let textInfo = [];
      this.aDataList.forEach(data => {
        if (data.checked) {
          ids.push({
            value: data.id
          });
          textInfo.push(data.name);
          sysList.push(data);
        }
      });
      return {
        ids,
        list: sysList,
        textInfo
      };
    }
  },
  methods: {
    async getChartConfigList() {
      this.startLoading();
      const { bean } = await this.$services.post({
        type: 'ECHARTMANGEMENT',
        url: 'getList',
        params: this.queryParams
      });

      for (let i = 0; i < bean.list.length; i++) {
        let item = bean.list[i];
        item.checked = false;
        item.index = bean.pageSize * (bean.pageNum - 1) + (i + 1);
      }
      this.aDataList = bean.list;
      this.total = bean.total;
      this.stopLoading();
    },
    async deleteChartConfig(ids) {
      const { status } = await this.$services.post({
        type: 'ECHARTMANGEMENT',
        url: 'toDelete',
        params: {
          ids: JSON.stringify(ids)
        }
      });

      if (status) {
        this.$message({
          type: 'success',
          message: '删除成功!'
        });
        this.refresh();
      }
      else {
        this.$message({
          type: 'error',
          message: '删除失败!'
        });
      }
    },
    startLoading() {
      this.loading = true;
    },
    stopLoading() {
      this.loading = false;
    },
    showDialog(dialogType) {
      this.dialogType = dialogType;
      this.bShowDialog = true;
    },
    closeDialog() {
      this.bShowDialog = false;
      this.clearChecked();
    },
    clearChecked() {
      this.$refs['tableList'].$refs['multipleTable'].clearSelection();
    },
    refresh() {
      this.closeDialog();
      this.getChartConfigList();
    },
    handleSizeChange(size) {
      this.queryParams.pageSize = size;
      this.getChartConfigList();
    },
    handleCurrentChange(currentPage) {
      this.queryParams.currentPage = currentPage;
      this.getChartConfigList();
    },
    detail() {
      if (this.selected.list.length === 0) {
        this.$toaster.error('请选择一条数据');
        return;
      }
      let [oActiveItem] = this.selected.ids;
      this.currentId = oActiveItem.value;
      this.showDialog('detail');
    },
    update() {
      if (this.selected.list.length === 0) {
        this.$message({
          message: '请选择一条数据',
          type: 'warning'
        });
        return;
      }
      let [oActiveItem] = this.selected.ids;
      this.currentId = oActiveItem.value;
      this.showDialog('update');
    },
    adelete() {
      let ids = [];
      let textInfo = [];
      for (let i = 0; i < this.aDataList.length; i++) {
        let item = this.aDataList[i];
        if (item.checked) {
          ids.push({
            value: item.id
          });
          textInfo.push(item.name);
        }
      }

      if (ids.length > 0) {
        this.$confirm(
          `此操作将永久删除数据<span style="color:red;padding:0 4px;"> ${textInfo.join(
            ','
          )} </span>, 是否继续?`,
          '提示',
          {
            dangerouslyUseHTMLString: true,
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }
        )
          .then(() => {
            this.deleteChartConfig(ids);
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          });
      }
      else {
        this.$message({
          message: '请选择一条数据',
          type: 'warning'
        });
      }
    }
  },
  mounted() {
    this.queryParams.depCode = this.userInfor.depCode;
    this.queryParams.userId = this.userId;
    this.getChartConfigList();
  }
};
</script>

<style lang="scss" scoped>
.marginLR {
  margin-left: 15px;
  margin-right: 5px;
}
</style>
